import React, { useState } from 'react';
import cx from 'classnames';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import Tooltip from '../Tooltip';
import stylesheet from './index.css';

export type SegmentedControlProps = {
  size?: 'large' | 'medium' | 'small';
  onClick?: (option: string | number) => void;
  showTooltip?: boolean;
  nowrap?: boolean;
} & (
  | {
      options: { label: string; icon: unknown; id: string | number }[];
      type: 'icon' | 'icon_and_text';
    }
  | {
      options: { label: string; id: string | number }[];
      type: 'text';
    }
);
const SegmentedControl = React.forwardRef<$TSFixMe, SegmentedControlProps>(
  function SegmentedControl(
    {
      size = 'large',
      type,
      options,
      onClick,
      showTooltip = true,
      nowrap = false,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forwardedRef,
  ) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const isReleased = mcdsFlagCheck(
      'xp_mcds_redesign_components_organisms_part_2',
    );
    if (type === 'icon' || type === 'icon_and_text') {
      options = options.map((option) => ({
        label: option.label,
        icon: (
          // @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message
          <option.icon
            size={
              size === 'small'
                ? 'xsmall'
                : size === 'large'
                ? 'medium'
                : 'small'
            }
            data-testid={option.label}
          />
        ),
        id: option.id,
      }));
    }
    return (
      isReleased && (
        <div
          className={cx(
            stylesheet.segmentedControlContainer,
            stylesheet[size],
            stylesheet[type],
            !nowrap && stylesheet.wrap,
          )}
        >
          {options.map((option, index) =>
            type === 'icon' && showTooltip ? (
              <Tooltip label={option.label} key={index}>
                <div
                  key={index}
                  className={cx(
                    stylesheet.segmentedControlOption,
                    stylesheet[size],
                    stylesheet[type],
                    index === selectedIndex && stylesheet.selected,
                  )}
                  onClick={() => {
                    setSelectedIndex(index);
                    if (onClick) {
                      onClick(option.id);
                    }
                  }}
                  onFocus={() => {
                    if (onClick) {
                      onClick(option.id);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'ArrowRight') {
                      e.preventDefault();
                      const nextIndex = index + 1;
                      const nextElement =
                        e.currentTarget.parentElement?.children[nextIndex];
                      if (nextElement instanceof HTMLElement) {
                        nextElement.focus();
                        setSelectedIndex(nextIndex);
                      }
                    } else if (e.key === 'ArrowLeft') {
                      e.preventDefault();
                      const prevIndex = index - 1;
                      if (prevIndex >= 0) {
                        const prevElement =
                          e.currentTarget.parentElement?.children[prevIndex];
                        if (prevElement instanceof HTMLElement) {
                          prevElement.focus();
                          setSelectedIndex(prevIndex);
                        }
                      }
                    }
                  }}
                  tabIndex={index === selectedIndex ? 0 : -1}
                  aria-selected={index === selectedIndex}
                >
                  {type === 'icon' ? (
                    showTooltip ? (
                      <div className={stylesheet.tooltipIcon}>
                        {/* @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message */}
                        {option.icon}
                      </div>
                    ) : (
                      <div className={stylesheet.tooltipIcon}>
                        {/* @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message */}
                        {option.icon}
                      </div>
                    )
                  ) : type === 'text' ? (
                    option.label
                  ) : (
                    <div className={stylesheet.iconAndText}>
                      <div className={stylesheet.tooltipIcon}>
                        {/* @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message */}
                        {option.icon}
                      </div>
                      <span>{option.label}</span>
                    </div>
                  )}
                </div>
              </Tooltip>
            ) : (
              <div
                key={index}
                className={cx(
                  stylesheet.segmentedControlOption,
                  stylesheet[size],
                  stylesheet[type],
                  index === selectedIndex && stylesheet.selected,
                )}
                onClick={() => {
                  setSelectedIndex(index);
                  if (onClick) {
                    onClick(option.id);
                  }
                }}
                onFocus={() => {
                  if (onClick) {
                    onClick(option.id);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    const nextIndex = index + 1;
                    const nextElement =
                      e.currentTarget.parentElement?.children[nextIndex];
                    if (nextElement instanceof HTMLElement) {
                      nextElement.focus();
                      setSelectedIndex(nextIndex);
                    }
                  } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const prevIndex = index - 1;
                    if (prevIndex >= 0) {
                      const prevElement =
                        e.currentTarget.parentElement?.children[prevIndex];
                      if (prevElement instanceof HTMLElement) {
                        prevElement.focus();
                        setSelectedIndex(prevIndex);
                      }
                    }
                  }
                }}
                tabIndex={index === selectedIndex ? 0 : -1}
                aria-selected={index === selectedIndex}
              >
                {type === 'icon' ? (
                  showTooltip ? (
                    <div className={stylesheet.tooltipIcon}>
                      {/* @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message */}
                      {option.icon}
                    </div>
                  ) : (
                    <div className={stylesheet.tooltipIcon}>
                      {/* @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message */}
                      {option.icon}
                    </div>
                  )
                ) : type === 'text' ? (
                  option.label
                ) : (
                  <div className={stylesheet.iconAndText}>
                    {/* @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type 'Props... Remove this comment to see the full error message */}
                    <div className={stylesheet.tooltipIcon}>{option.icon}</div>
                    <span>{option.label}</span>
                  </div>
                )}
              </div>
            ),
          )}
        </div>
      )
    );
  },
);

export default SegmentedControl;
